const RareBoxLogo = ({ width = 200 }) => {
	return (
		<div style={{ marginLeft: "-4px" }}>
			<svg width={width} viewBox="0 0 244 62" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M5.28409 58V14.3636H20.0284C23.4375 14.3636 26.2358 14.946 28.4233 16.1108C30.6108 17.2614 32.2301 18.8452 33.2812 20.8622C34.3324 22.8793 34.858 25.1733 34.858 27.7443C34.858 30.3153 34.3324 32.5952 33.2812 34.5838C32.2301 36.5724 30.6179 38.1349 28.4446 39.2713C26.2713 40.3935 23.4943 40.9545 20.1136 40.9545H8.18182V36.1818H19.9432C22.2727 36.1818 24.1477 35.8409 25.5682 35.1591C27.0028 34.4773 28.0398 33.5114 28.679 32.2614C29.3324 30.9972 29.6591 29.4915 29.6591 27.7443C29.6591 25.9972 29.3324 24.4702 28.679 23.1634C28.0256 21.8565 26.9815 20.848 25.5469 20.1378C24.1122 19.4134 22.2159 19.0511 19.858 19.0511H10.5682V58H5.28409ZM25.8239 38.3977L36.5625 58H30.4261L19.858 38.3977H25.8239ZM43.663 58V14.3636H69.9982V19.0511H48.9471V33.7955H68.6346V38.483H48.9471V53.3125H70.3391V58H43.663ZM79.5224 58V14.3636H84.8065V53.3125H105.091V58H79.5224Z"
					fill="black"
				/>
				<path
					d="M128 53C139.046 53 148 44.0457 148 33C148 21.9543 139.046 13 128 13C116.954 13 108 21.9543 108 33C108 44.0457 116.954 53 128 53Z"
					stroke="black"
					stroke-width="5"
				/>
				{/* <line x1="155" y1="60" x2="180" y2="75" stroke="#000000" stroke-width="5" stroke-linecap="round" /> */}
				<path
					d="M179 58C190.046 58 199 49.0457 199 38C199 26.9543 190.046 18 179 18C167.954 18 159 26.9543 159 38C159 49.0457 167.954 58 179 58Z"
					stroke="black"
					stroke-width="5"
				/>
				<path
					d="M210.284 58V14.3636H215.568V36.0114H216.08L235.682 14.3636H242.585L224.261 34.0511L242.585 58H236.193L221.023 37.7159L215.568 43.8523V58H210.284Z"
					fill="black"
				/>
			</svg>
		</div>
	);
};

export default RareBoxLogo;
